import { type TextInputProps } from '@mantine/core';
import { CopyToClipboardActionIcon } from '../actionIcons';
import { TextInput } from './TextInput';

interface CopyableTextInputProps extends Omit<TextInputProps, 'rightSection'> {
    showCopyButton?: boolean;
}

export const CopyableTextInput = ({
    value,
    defaultValue,
    showCopyButton = true,
    ...textInputProps
}: CopyableTextInputProps) => {
    const stringValue = String(value || defaultValue || '');

    return (
        <TextInput
            {...textInputProps}
            value={value}
            defaultValue={defaultValue}
            rightSection={showCopyButton && stringValue ? <CopyToClipboardActionIcon value={stringValue} /> : undefined}
        />
    );
};
